/**
 * Product inventory-log grid — filter -> param builder.
 *
 * Turns ProductInventoryLogGrid's filter state into the EntityGrid
 * `extraParams` object for odl-app/product-inventory-logs/. A product
 * picked via the toolbar's ProductAutocomplete scopes the grid by the
 * product's id (filter[product_id], exact) — never by its SKU text, which
 * is no longer guaranteed unique to one product (ENG-834's product FK).
 * Free-text SKU search stays on EntityGrid's built-in quick filter
 * (filter[search]), untouched by this builder.
 *
 * Contains:
 * - buildProductInventoryLogGridParams — filter state -> extraParams
 */

const FILTER_PRODUCT_ID = 'product_id';
const FILTER_ACTION = 'action';

/**
 * @param {Object} filters
 * @param {number} [filters.product] - id of the product picked via the
 *   toolbar autocomplete.
 * @param {string} [filters.action] - action-type filter value.
 * @returns {Object} EntityGrid extraParams
 */
export const buildProductInventoryLogGridParams = ({ product, action } = {}) => {
  const params = {};
  if (product) params[FILTER_PRODUCT_ID] = product;
  if (action) params[FILTER_ACTION] = action;
  return params;
};
